import { createContext } from 'react';

// Demo mode: an ADMIN user's session is swapped for the demo user's (linked only to the
// demo agency). App.js stashes the admin's own User so exiting restores it.
// Shape: { isDemoMode, adminUser, enterDemoMode(demoUser), exitDemoMode() }
const DemoModeContext = createContext({
    isDemoMode: false,
    adminUser: null,
    enterDemoMode: () => {},
    exitDemoMode: () => {}
});

export default DemoModeContext;
